import { render } from "./SSOButton.vue?vue&type=template&id=b8d6759e&scoped=true"
import script from "./SSOButton.vue?vue&type=script&lang=js"
export * from "./SSOButton.vue?vue&type=script&lang=js"

import "./SSOButton.vue?vue&type=style&index=0&id=b8d6759e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d6759e"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QBadge});
